import React from "react";
import LegalPage from "@/components/LegalPage";

export default function Copyright() {
  return (
    <LegalPage
      title="Copyright & Intellectual Property"
      eyebrow="Notice"
      testid="copyright-page"
    >
      <p>
        All artworks, paintings, photographs of artworks, written stories, descriptions, titles,
        and design elements published on <strong>colleenprosserart.com.au</strong> are the
        original creative work of <strong>Colleen Prosser</strong> and are protected by
        copyright and moral rights under the Copyright Act 1968 (Cth) and applicable
        international treaties.
      </p>

      <h2>1. Ownership</h2>
      <p>
        Copyright and all intellectual property rights in every artwork and the accompanying
        story remain at all times with Colleen Prosser. This includes, without limitation:
      </p>
      <ul>
        <li>The original painting itself.</li>
        <li>The photographic image of the painting displayed on this website.</li>
        <li>The story, narrative, title, and written description published alongside it.</li>
        <li>Any underlying design, motif, or composition created by the Artist.</li>
      </ul>

      <h2>2. Purchase Does Not Transfer Copyright</h2>
      <p>
        Purchasing an original artwork transfers ownership of the physical object only. It does
        <strong> not</strong> transfer copyright, reproduction rights, or moral rights. The
        purchaser may display the artwork privately or in their own home or premises, but may
        not:
      </p>
      <ul>
        <li>Reproduce, copy, scan, or digitise the artwork in any format.</li>
        <li>Print, publish, or sell prints, posters, postcards, merchandise or NFTs of the work.</li>
        <li>Use the image of the artwork in advertising, branding, packaging, books, or any
            commercial context.</li>
        <li>Adapt, alter, modify, or create derivative works from the artwork or its story.</li>
        <li>License or sub-license the artwork to any third party.</li>
      </ul>

      <h2>3. Stories &amp; Cultural Material</h2>
      <p>
        The stories attached to each painting are told by the Artist and carry cultural meaning.
        They are the cultural and intellectual property of Colleen Prosser and her community.
        They are shared on this website for the purpose of selling and contextualising the
        artwork only. They may not be retold, republished, paraphrased, recorded, performed, or
        used in research, journalism, books, or any other medium without the prior written
        consent of the Artist.
      </p>
      <p>
        Indigenous Cultural and Intellectual Property (ICIP) rights are recognised in addition
        to copyright. Respect for ICIP means honouring the Artist's authority over how her
        stories and cultural designs are used, even after a physical artwork has been sold.
      </p>

      <h2>4. Website Content</h2>
      <p>
        All other content on this website &mdash; including text, layout, graphics, code,
        photography of the artist, and the "Colleen Prosser Art" name and logo &mdash; is the
        property of Colleen Prosser or her licensors and is protected by copyright and
        trade-mark law.
      </p>

      <h2>5. Permitted Use</h2>
      <p>
        You may:
      </p>
      <ul>
        <li>Browse the website for the purpose of viewing or purchasing artworks.</li>
        <li>Share a link to a product page or the website on social media.</li>
        <li>Print a single copy of an order confirmation for your personal records.</li>
      </ul>
      <p>
        Any other use requires the Artist's prior written permission.
      </p>

      <h2>6. Licensing</h2>
      <p>
        If you would like to license an image of an artwork, or seek permission to reproduce a
        story (for example, in a gallery catalogue, book, or documentary), please email{" "}
        <a href="mailto:colleen.prosser@outlook.com">colleen.prosser@outlook.com</a>{" "}
        with details of your intended use. We respond to every licensing enquiry personally.
      </p>

      <h2>7. Infringement</h2>
      <p>
        Unauthorised use of any artwork, story, photograph or design constitutes copyright
        infringement and a breach of the Artist's moral and cultural rights. We actively
        monitor for infringement and reserve the right to:
      </p>
      <ul>
        <li>Issue take-down notices under the relevant safe-harbour scheme.</li>
        <li>Seek damages, an account of profits, and injunctive relief.</li>
        <li>Refer matters to the Australian Federal Police or the relevant cultural-heritage
            authority where ICIP rights are involved.</li>
      </ul>

      <h2>8. Reporting Misuse</h2>
      <p>
        If you have seen one of Colleen's artworks or stories being used without permission, we
        would be grateful if you would let us know at{" "}
        <a href="mailto:colleen.prosser@outlook.com">colleen.prosser@outlook.com</a>.
      </p>

      <p className="text-xs uppercase tracking-widest text-[#5B5653] pt-8 border-t border-[#E3DDD7]">
        © {new Date().getFullYear()} Colleen Prosser. All rights reserved · Last updated{" "}
        {new Date().toLocaleDateString("en-AU", { month: "long", year: "numeric" })}
      </p>
    </LegalPage>
  );
}
